import { render } from "./InsightOffcanvas.vue?vue&type=template&id=01411318&scoped=true"
import script from "./InsightOffcanvas.vue?vue&type=script&lang=ts"
export * from "./InsightOffcanvas.vue?vue&type=script&lang=ts"

import "./InsightOffcanvas.vue?vue&type=style&index=0&id=01411318&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-01411318"

export default script